import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Components as TextAreaComponents } from './textArea.style';
import Label from '../Label';
import ErrorMessage from '../ErrorMessage';
import Hint from '../Hint';
const TextArea = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      className = 'textarea',
      id,
      error,
      hint,
      onChange,
      focus,
      width,
      value,
      disabled,
      required,
      fit = 'medium',
      rows = 5,
      maxLength,
      label
    } = props,
    rest = __rest(props, ["className", "id", "error", "hint", "onChange", "focus", "width", "value", "disabled", "required", "fit", "rows", "maxLength", "label"]);
  return _jsxs(TextAreaComponents.Wrapper, _extends({
    className: className,
    width: width
  }, {
    children: [label && _jsx(Label, _extends({
      label: label,
      id: id,
      fit: fit,
      className: className,
      required: required
    }, rest)), _jsx(TextAreaComponents.Area, {
      children: _jsx(TextAreaComponents.TextArea, _extends({
        id: id,
        ref: ref,
        autoFocus: focus,
        onChange: onChange,
        error: error,
        value: value,
        fit: fit,
        rows: rows,
        maxLength: maxLength,
        disabled: disabled,
        "aria-describedby": "hint errormsg",
        "aria-required": required
      }, rest))
    }), error && _jsx(ErrorMessage, _extends({
      fit: fit
    }, rest)), hint && _jsx(Hint, _extends({
      hint: hint,
      fit: fit
    }, rest))]
  }));
});
export default TextArea;